import { createSelector } from "reselect";
import { parseISO, differenceInDays, addDays } from "date-fns";

const getSubscriptions = (state) => state.entities.subscriptions;
const getSubscriptionsListState = (state) => state.subscriptionsList || {};
const getId = (_, id) => id;
const getProductId = (_, productId) => productId;
export const getSubscriptionLoading = (state) => state.subscriptionsList.loading;
export const getSubscriptionError = (state) => state.subscriptionsList.error;
export const getCoursesUsers = (state) => state.entities.coursesUsers;

export const getAllCoursesUsers = createSelector(getCoursesUsers, (coursesUsers) =>
  Object.values(coursesUsers)
);

export const getAllSubscriptions = createSelector(getSubscriptions, (subscriptions) =>
  Object.values(subscriptions)
);

export const getSubscriptionById = createSelector(
  getSubscriptions,
  getId,
  (subscriptions, id) => subscriptions[id]
);

export const getSubscriptionWithPendingPayment = createSelector(
  getAllSubscriptions,
  (subscriptions) => subscriptions.find((subscription) => !!subscription.pendingPixPayment)
)

export const selectActiveSubscription = createSelector(
  getAllSubscriptions,
  (subscriptions) =>
    subscriptions.find((subscription) => subscription.status === "active")
);

export const getSubscriptionAccessEndDate = createSelector(
  getSubscriptions,
  getId,
  getAllCoursesUsers,
  (subscriptions, id, coursesUsers) => {
    const subscription = subscriptions[id];
    if (!subscription?.purchases?.length) return null;

    const coursesUser = coursesUsers?.find((coursesUser) => coursesUser.externalId === subscription.paymentServiceId);
    if (coursesUser) return coursesUser.expiresAt;

    return null;
  }
);

export const getSubscriptionCanRefundUntil = createSelector(
  getSubscriptions,
  getId,
  (subscriptions, id) => {
    const subscription = subscriptions[id];
    if (!subscription?.purchases?.length) return null;

    const now = new Date();
    const purchase = subscription.purchases.find((purchase) => {
      const purchaseDate = parseISO(purchase.createdAt);
      const daysDiff = differenceInDays(now, purchaseDate);
      return daysDiff <= 7;
    });

    if (!purchase?.createdAt) return null;

    const purchaseDate = parseISO(purchase.createdAt);
    return addDays(purchaseDate, 7);
  }
);

export const getProductSubscriptions = createSelector(
  getSubscriptions,
  getProductId,
  getSubscriptionsListState,
  (subscriptions, productId, subscriptionsList) => {
    const productSubscriptionIds = subscriptionsList.productSubscriptions?.[productId];
    if (!productSubscriptionIds) return [];

    const subscriptionIds = productSubscriptionIds.ids || [];
    return subscriptionIds.map(id => subscriptions[id]).filter(Boolean);
  }
);

export const getProductSubscriptionsPagination = createSelector(
  getSubscriptionsListState,
  getProductId,
  (subscriptionsList, productId) => {
    return subscriptionsList.productSubscriptions?.[productId]?.pagination || null;
  }
);

export const getProductSubscriptionsLoading = createSelector(
  getSubscriptionsListState,
  (subscriptionsList) => subscriptionsList.loading
);
